import { render, staticRenderFns } from "./periodic-wizard-drafts.vue?vue&type=template&id=d0fe1d50&"
import script from "./periodic-wizard-drafts.vue?vue&type=script&lang=js&"
export * from "./periodic-wizard-drafts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports